<div class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4 font">
  <div class="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center transform hover:scale-105 transition-all duration-300">

    <!-- Checkmark Icon -->
    <div class="mb-6">
      <div class="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center animate-pulse">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="lucide lucide-check-circle w-12 h-12 text-green-600">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <path d="m9 11 3 3L22 4"></path>
        </svg>
      </div>
    </div>

    <!-- Title & Subtitle -->
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-4 leading-tight">{{ 'VALUES.THANK_YOU' | translate }}</h1>
      <p class="text-lg text-gray-700 leading-relaxed mb-6">{{ 'VALUES.PAYMENT_SUCCESS_SUBSCRIPTION' | translate }}</p>
      <div class="w-16 h-1 bg-green-500 mx-auto rounded-full"></div>
    </div>

    <!-- Info / Details -->
    <div class="space-y-4 mb-8">
      <div class="flex items-center justify-center space-x-3 text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="lucide lucide-mail w-5 h-5 text-green-500">
          <rect width="20" height="16" x="2" y="4" rx="2"></rect>
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
        </svg>
        <span class="text-sm">{{ 'VALUES.PAYMENT_RECEIVED' | translate }}</span>
      </div>
    </div>

    <!-- Next Steps Box -->
    <div class="bg-green-50 rounded-xl p-6 border border-green-100">
      <p class="text-gray-700 text-sm leading-relaxed">{{ 'VALUES.SUBSCRIPTION_NEXT_STEPS' | translate }}</p>
    </div>

    <!-- Footer / Appreciation -->
    <div class="mt-8 pt-6 border-t border-gray-100">
      <p class="text-xs text-gray-500">{{ 'VALUES.APPRECIATION' | translate }}</p>
    </div>
  </div>

  <!-- Background Shapes -->
  <div class="fixed inset-0 -z-10 overflow-hidden">
    <div class="absolute top-1/4 left-1/4 w-32 h-32 bg-green-200 rounded-full opacity-20 animate-pulse"></div>
    <div class="absolute bottom-1/4 right-1/4 w-24 h-24 bg-green-300 rounded-full opacity-15 animate-pulse delay-1000"></div>
    <div class="absolute top-3/4 left-1/3 w-16 h-16 bg-green-400 rounded-full opacity-10 animate-pulse delay-2000"></div>
  </div>
</div>
